import script from "./StudioView.vue?vue&type=script&lang=ts&setup=true"
export * from "./StudioView.vue?vue&type=script&lang=ts&setup=true"

import "./StudioView.vue?vue&type=style&index=0&id=8b1308b4&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b1308b4"]])

export default __exports__